export default __webpack_public_path__ + "942b2991978590454773a7b224b8a3e7.jpg";